module.exports = __webpack_public_path__ + "img/item1.4832bd6f.png";